import { TrackingEvent } from 'client/tracking/event';
import { CommonMap } from 'client/tracking/maps/common';
import { MiniInventoryMap } from 'client/tracking/maps/components/mini-inventory/mini-inventory';
import { TrackingConstant } from 'client/tracking/constant';

const map = {
  view_ev_tax_credit: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.VIEW_EV_TAX_CREDIT
  ),
  appraise_your_car: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.APPRAISE_YOUR_CAR
  ),
  fs_model_select: TrackingEvent.actionProgress(TrackingConstant.ACTION_MMY_SELECT, TrackingConstant.MODEL_SELECT, {
    action_cause: TrackingConstant.SELECT_CHANGE,
    creative_id: 'features-specs-style-dropdown',
  }),
  expand_specs_module: TrackingEvent.actionCompleted(TrackingConstant.ACTION_VIEW_CONTENT, 'expand_specs_module'),
  view_specs_non_docked: TrackingEvent.actionCompleted(TrackingConstant.ACTION_VIEW_CONTENT, 'view_specs_non_docked'),
};

export const FeaturesSpecsMap = {
  ...CommonMap,
  ...MiniInventoryMap,
  ...map,
};
